import React, { useState, useEffect } from 'react';
import AdminLayout from './AdminLayout';
import adminApi from '../../api/adminClient';
import './Admin.css';

const emptyForm = {
  representative: '', address: '', phone: '', mobile: '', fax: '', email: '',
  business_hours: '', subway_info: '', bus_info: '', car_info: '', business_number: '',
};

export default function AdminCompany() {
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => { loadCompany(); }, []);

  async function loadCompany() {
    try {
      const data = await adminApi.get('/company');
      setForm({
        representative: data.representative || '',
        address: data.address || '',
        phone: data.phone || '',
        mobile: data.mobile || '',
        fax: data.fax || '',
        email: data.email || '',
        business_hours: data.business_hours || '',
        subway_info: data.subway_info || '',
        bus_info: data.bus_info || '',
        car_info: data.car_info || '',
        business_number: data.business_number || '',
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setSuccess(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError(null);
    setSuccess(false);
    try {
      await adminApi.put('/company', form);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <AdminLayout>
      <div className="admin-header">
        <div>
          <h1>회사 정보 관리</h1>
          <p className="text-muted">홈페이지에 표시되는 회사 기본 정보를 관리합니다.</p>
        </div>
      </div>

      {loading ? (
        <div className="state-message">불러오는 중입니다...</div>
      ) : (
        <div className="admin-form-card">
          {error && <div className="admin-alert admin-alert--error">{error}</div>}
          {success && <div className="admin-alert admin-alert--success">저장되었습니다.</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-row-2">
              <div className="form-group">
                <label>대표자명</label>
                <input name="representative" value={form.representative} onChange={handleChange} placeholder="홍길동" />
              </div>
              <div className="form-group">
                <label>사업자번호 <span style={{ fontSize: '0.8em', color: 'var(--gray-500)' }}>(근로계약서에 표시)</span></label>
                <input name="business_number" value={form.business_number} onChange={handleChange} placeholder="000-00-00000" />
              </div>
            </div>
            <div className="form-row-2">
              <div className="form-group">
                <label>전화번호</label>
                <input name="phone" value={form.phone} onChange={handleChange} placeholder="02-0000-0000" />
              </div>
              <div className="form-group">
                <label>휴대폰번호</label>
                <input name="mobile" value={form.mobile} onChange={handleChange} placeholder="010-0000-0000" />
              </div>
            </div>
            <div className="form-row-2">
              <div className="form-group">
                <label>팩스</label>
                <input name="fax" value={form.fax} onChange={handleChange} placeholder="02-0000-0001" />
              </div>
              <div className="form-group">
                <label>이메일</label>
                <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="info@company.com" />
              </div>
            </div>
            <div className="form-group">
              <label>주소 <span style={{ fontSize: '0.8em', color: 'var(--gray-500)' }}>(줄바꿈 가능, 근로계약서 소재지)</span></label>
              <textarea name="address" value={form.address} onChange={handleChange} rows={2} placeholder="서울특별시 강남구 테헤란로 XX&#10;(상세주소)" />
            </div>
            <div className="form-group">
              <label>업무시간</label>
              <input name="business_hours" value={form.business_hours} onChange={handleChange} placeholder="평일 09:00 ~ 18:00 (주말 및 공휴일 휴무)" />
            </div>

            <div className="admin-section-divider">교통편 안내</div>

            <div className="form-group">
              <label>지하철</label>
              <textarea name="subway_info" value={form.subway_info} onChange={handleChange} rows={2} placeholder="예: 2호선 강남역 1번 출구에서 도보 5분" />
            </div>
            <div className="form-group">
              <label>버스</label>
              <textarea name="bus_info" value={form.bus_info} onChange={handleChange} rows={2} placeholder="예: 강남역 정류장 하차 (140, 146번)" />
            </div>
            <div className="form-group">
              <label>자가용</label>
              <textarea name="car_info" value={form.car_info} onChange={handleChange} rows={2} placeholder="예: 건물 지하 주차장 이용 (방문 시 1시간 무료)" />
            </div>

            <div className="admin-form-actions">
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? '저장 중...' : '저장하기'}
              </button>
            </div>
          </form>
        </div>
      )}
    </AdminLayout>
  );
}
